<script setup>
import {ref} from 'vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import ImgMedia from '@/Components/Images/ImgMedia.vue';

defineProps({
    title: String,
    gallery: Object,
    aspect_ratio: String,
});

const visibleRef = ref(false);
const indexRef = ref(0);
const showImg = (index) => {
    indexRef.value = index;
    visibleRef.value = true;
};
const onHide = () => (visibleRef.value = false);
</script>

<template>
    <div class="container py-12 md:py-16">
        <div class="flex flex-col items-center">
            <h2
                v-if="title"
                class=""
                v-html="title"
            />
        </div>

        <div class="grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
            <div
                v-for="(image, index) in gallery"
                :key="index"
                @click="() => showImg(index)"
            >
                <div

                    :style="aspect_ratio"
                    class="pic relative aspect-square overflow-hidden"
                >
                    <ImgMedia
                        :media="image.image"
                        :sizes="{ default: '100vw', '(min-width: 768px)': '600px' }"
                        alt="image"
                        classes="absolute inset-0 object-cover w-full h-full "
                    />
                </div>
                <div
                    v-if="image.text"
                    class="prose max-w-full rounded-b-xl bg-gray-lighter p-6 text-bodyColor marker:text-primary prose-a:font-bold prose-a:transition-colors prose-a:hover:text-primary"
                    v-html="image.text"
                />
            </div>
        </div>

        <vue-easy-lightbox
            :imgs="gallery.map((item) => item.image?.src).filter(e => e)"
            :index="indexRef"
            :move-disabled="true"
            :visible="visibleRef"
            @hide="onHide"
        />
    </div>
</template>
